/** Public support inbox — shown in footer and /support as mailto. */
export const SUPPORT_EMAIL = 'support@arevina.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;

/** Plain messages for a broken sign-in or sign-up setup. Technical details go to the console only. */
export const SIGN_IN_UNAVAILABLE_MESSAGE = `Sign-in isn't working right now. Please try again in a few minutes, or email ${SUPPORT_EMAIL}.`;
export const SIGN_UP_UNAVAILABLE_MESSAGE = `We couldn't finish setting up your account. Please try again, or email ${SUPPORT_EMAIL}.`;
